import { Resource as e, API as a } from "@coveo/platform-client";
const t = class t extends e {
  startJob(s) {
    return this.api.post(t.baseUrl, s);
  }
  getJobStatus(s) {
    return this.api.get(`${t.baseUrl}/${s}/status`);
  }
  getChunks(s) {
    return this.api.get(`${t.baseUrl}/${s}/result`);
  }
};
t.baseUrl = `/rest/organizations/${a.orgPlaceholder}/chunkinspector/searchquery/v1/chunkretrievaljobs`;
let r = t;
export {
  r as ChunkInspectorSearchResource
};
//# sourceMappingURL=ChunkInspectorSearch.js.map
